import cn from 'classnames'
import React, { PureComponent } from 'react'
import Link from 'redux-first-router-link'

import { Form, Button, Icon } from 'util/ui'
import { propFunc } from 'util/functions'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import ValidatedField from 'shared/components/ui/ValidatedField'
import { Tip } from 'shared/components/ui/Typography'

import sharedStyles from '../../../sharedForm/styles.less'
import { COMPLETED_PAGE } from '../../pages'

import styles from '../styles.less'

export default class AddTeamMembersSingleInputFormView extends PureComponent {
  handleChange = (name, _, { value, checked }) => {
    const { onChange } = this.props
    onChange(name, checked === undefined ? value : checked)
  }

  handleBlur = name => {
    const { onValidate, formFields } = this.props
    onValidate(name, formFields[name])
  }

  render() {
    const {
      switchInputMode,
      formFields,
      formFieldsErrors,
      submitForm,
      canSave,
      saving,
      invitationErrors,
      backPageType,
    } = this.props

    return (
      <Form size="large" className={sharedStyles.form}>
        {[0, 1, 2].map(index => {
          const key = `emailAddress${index}Input`
          return (
            <Form.Field key={key}>
              <ValidatedField
                placeholder="team-member@organization.com"
                type="email"
                value={formFields[key]}
                errorMessage={formFieldsErrors[key]}
                onChange={propFunc(this.handleChange, key)}
                onBlur={propFunc(this.handleBlur, key)}
                fieldRefCallback={disableLastPassInputRef}
              />
            </Form.Field>
          )
        })}
        <Form.Field>
          Need to add a bunch of {app.t('agents')}?{' '}
          <a onClick={switchInputMode}>Click here</a>
        </Form.Field>
        <Form.Field>
          <hr />
        </Form.Field>
        {!!invitationErrors &&
          invitationErrors.map((error, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Form.Field key={`onboarding-addteam-single-error-${index}`}>
              <Tip color="berry" className={styles.errorMessage}>
                <Icon name="times circle outline" />
                {error}
              </Tip>
            </Form.Field>
          ))}
        {!!invitationErrors && (
          <Form.Field>
            <hr />
          </Form.Field>
        )}
        <Form.Group>
          <Form.Field width={4}>
            <Link to={{ type: backPageType }}>
              <Button size="big" fluid basic>
                Back
              </Button>
            </Link>
          </Form.Field>
          <Form.Field width={12}>
            <Button
              primary
              size="big"
              fluid
              disabled={!canSave}
              onClick={submitForm}
            >
              {!saving ? 'Invite' : 'Sending invites...'}
            </Button>
            <Link
              to={{ type: COMPLETED_PAGE }}
              className={cn(sharedStyles.skipStep, styles.skipStep)}
            >
              Skip this step
            </Link>
          </Form.Field>
        </Form.Group>
      </Form>
    )
  }
}
